import { PapercupThemeProvider, Toaster } from "@papercup-ai/orizuru";
import { ErrorBoundary as SentryErrorBoundary } from "@sentry/nextjs";
import { KATANA_E2E_AUTH } from "../constants/env";
import Auth0Wrapper from "../pages/Base/Auth0Wrapper";
import { ApolloProvider } from "../providers/ApolloProvider";
import { SessionProvider } from "../providers/SessionProvider";
import { MaintenanceGate } from "./MaintenanceGate";

// PapercupThemeProvider component wraps both ChakraProvider and ThemeProvider from next-themes
import { FlagsmithProviderWrapper } from "../providers/featureFlags/FlagsmithProviderWrapper";
import { E2EProfileProvider } from "../providers/profileProvider/E2EProfileProvider";
import { ProfileProvider } from "../providers/profileProvider/ProfileProvider";
import { StageCompletedModal } from "./studio/StageCompletedModal";

type Props = {
  children: React.ReactNode;
};

const Providers = ({ children }: Props) => {
  // App-wide maintenance page and notice overlay: they need the profile (for
  // Flagsmith identity) but no page context, so they sit here, outside every
  // page, instead of in each layout.
  const page = <MaintenanceGate>{children}</MaintenanceGate>;

  return (
    <SentryErrorBoundary>
      <PapercupThemeProvider>
        {KATANA_E2E_AUTH ? (
          <E2EProfileProvider>
            <FlagsmithProviderWrapper>
              <ApolloProvider>
                <SessionProvider>{page}</SessionProvider>
              </ApolloProvider>
            </FlagsmithProviderWrapper>
          </E2EProfileProvider>
        ) : (
          <Auth0Wrapper>
            <ProfileProvider>
              <FlagsmithProviderWrapper>
                <ApolloProvider>
                  <SessionProvider>{page}</SessionProvider>
                </ApolloProvider>
              </FlagsmithProviderWrapper>
            </ProfileProvider>
          </Auth0Wrapper>
        )}
        <Toaster />
        {/* Outside Studio so it survives the post-approval redirect. */}
        <StageCompletedModal />
      </PapercupThemeProvider>
    </SentryErrorBoundary>
  );
};

export default Providers;
